import "dayjs/locale/uk";

import { useContext, useEffect, useState } from "react";

import DatePicker from "antd/lib/date-picker";
import Directories from "../../../../../../directories";
import Documents from "../../../../../../documents";
import Drawer from "../../../../../../ui/drawer";
import Form from "antd/lib/form";
import { FormContext } from "../../../../../../../contexts/form/index.context";
import Input from "antd/lib/input";
import { MergedColumnType } from "../../../../../../ui/table/utils/types";
import { ModalContext } from "../../../../../../../contexts/modal/index.context";
import Select from "antd/lib/select";
import { SessionContext } from "../../../../../../../contexts/session/index.context";
import Space from "antd/lib/space";
import { TableContext } from "../../../../../../../contexts/table/index.context";
import { TranslationContext } from "../../../../../../../contexts/translation/index.context";
import customParseFormat from "dayjs/plugin/customParseFormat";
import dayjs from "dayjs";
import { request } from "../../../../../../../services";
import { DrawerProvider } from "../../../../../../../contexts/drawer/index.context";
import styles from "../styles.module.scss";

import en from "antd/es/date-picker/locale/en_US";
import ua from "antd/es/date-picker/locale/uk_UA";

//Components
//UI
//Locale

dayjs.extend(customParseFormat);
dayjs.locale("uk");

const { TextArea } = Input;

export function Passing({ pathname }: { pathname: string }) {
  // console.log("Passing component");
  const { intl, language } = useContext(TranslationContext);
  const { form } = useContext(FormContext);
  const { activeModal } = useContext(ModalContext);
  const { sessionData } = useContext(SessionContext);
  const { rowData } = useContext(TableContext);
  const edit = activeModal === "edit";
  const [selectData, setSelectData] = useState<MergedColumnType[]>([]);
  const [selectDataControlType, setSelectDataControlType] = useState<
    MergedColumnType[]
  >([]);
  const [selectedActionStage, setSelectedActionStage] = useState<number | null>(
    null
  );
  
  const [marshDocId, setMarshDocId] = useState<number | undefined>(edit ? sessionData.MarshDocID : undefined);
  const [controlsId, setControlsId] = useState<number | undefined>(edit ? sessionData.eta_TypeDoc_relation_id : undefined);
  const dateFormatList = ["DD.MM.YYYY", "DD-MM-YYYY"];

  const selectOptions = selectData.map((item) => ({
    value: item.id,
    label: item.name,
    isKontrol: item.isKontrol,
  }));

  const selectOptionsControlType = selectDataControlType.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  useEffect(() => {
    if (sessionData?.isKontrol === 1) {
      setSelectedActionStage(1);
    }
  }, [sessionData]);

  //   useEffect(() => {
  //   console.log("Passing EDIT========== ", edit);
  //   console.log("Passing language========== ", language);
  // }, [rowData, sessionData]);

  function setFormFields() {
    // console.log("Passing EDIT========== ", edit);

    if (/* edit &&  */ rowData) {
      const fieldsValue: any = {};
      if (rowData["/directories/employees-and-contact-persons"]) {
        setMarshDocId(rowData["/directories/employees-and-contact-persons"].data.id);
        fieldsValue.performer =
          rowData["/directories/employees-and-contact-persons"].data.exec_id;
        fieldsValue.performerType =
          rowData["/directories/employees-and-contact-persons"].data.typerec;
        fieldsValue.performerFioId =
          rowData["/directories/employees-and-contact-persons"].data.exec_fio_id;
        // console.log("SET FORMFIELDS ============ ", fieldsValue.performerFioId);
      }
      if (rowData["/directories/employees"] && edit) {
        fieldsValue.controls = rowData["/directories/employees"].id;
        setControlsId(rowData["/directories/employees"].id);
      }

      form.setFieldsValue(fieldsValue);
    }
  }

  const fetchSelectData = async () => {
    const content = (
      await request(`${pathname}/getdataselect`, {
        method: "post",
        cancelTokenKey: "getdataselect",
      })
    )?.content;
    setSelectData(content || []);
  };

  const fetchSelectDataControlType = async () => {
    const content = (
      await request(`${pathname}/getdataselect`, {
        method: "post",
        body: { str: "controlType" },
        cancelTokenKey: "getdataselect",
      })
    )?.content;
    setSelectDataControlType(content || []);
  };

  return (
    <>
      <DrawerProvider>
      <Form.Item
        label={intl("action-stage")}
        name="actionStage"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Select
          labelInValue
          onChange={(value) => {
            const selectedOption = selectData.find(
              (item) => item.id === value?.value
            );
            setSelectedActionStage(
              selectedOption?.isKontrol === 1 ? value.value : null
            );
            form.setFieldsValue({ actionStage: value });
          }}
          onDropdownVisibleChange={fetchSelectData}
          options={selectOptions}
          allowClear
          disabled={edit}
        />
      </Form.Item>
      
      <Form.Item
        label={intl("performer")}
        name="performerFioId"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Drawer
          url="/directories/employees-and-contact-persons"
          name={edit ? sessionData.Executors_FIO_name : undefined}
          name2={
            rowData["/directories/employees-and-contact-persons"]?.data
              .contact_person
          }
          setFormFields={setFormFields}
          fieldName={"performerFioId"}
        >
          <Directories url="/directories/employees-and-contact-persons" selectedRowId={marshDocId} />
        </Drawer>
      </Form.Item>

      <Form.Item name="performerType" hidden />
      <Form.Item name="performer" hidden />
      {/* <Input />
      </Form.Item> */}

      <Form.Item label={intl("controls")} name="controls">
        <Drawer
          url="/directories/employees"
          name={edit ? sessionData.Controllers_fio : undefined}
          name2={edit ? rowData["/directories/employees"]?.data.fio : undefined}
          setFormFields={setFormFields}
          fieldName={"controls"}
        >
          <Directories url="/directories/employees" selectedRowId={controlsId} />
        </Drawer>
      </Form.Item>
      <Space>
        <Form.Item
          label={intl("date-of-transfer-to-the-contractor")}
          name="dateOfTransferToTheContractor"
        >
          <DatePicker
            format={dateFormatList}
            style={{ width: "100%" }}
            placeholder={intl("choose-date-placeholder")}
            locale={language ? ua : en}
          />
        </Form.Item>
        <Form.Item label={intl("date-of-control")} name="dateOfControl">
          <DatePicker
            format={dateFormatList}
            style={{ width: "100%" }}
            disabled={selectedActionStage ? false : true}
            placeholder={intl("choose-date-placeholder")}
            locale={language ? ua : en}
          />
        </Form.Item>
        <Form.Item
          label={intl("scheduled-execution-date")}
          name="scheduledExecutionDate"
        >
          <DatePicker
            format={dateFormatList}
            style={{ width: "100%" }}
            disabled={selectedActionStage ? true : false}
            placeholder={intl("choose-date-placeholder")}
            locale={language ? ua : en}
          />
        </Form.Item>
      </Space>
      {selectedActionStage && (
        <Space className={styles["wrapperTypeControl"]}>
          <span className={styles["titleForWrapper"]}>{intl("control-action")}</span>
        <Space direction="vertical" style={{ width: "100%" }}>
          <Form.Item label={intl("control-type")} name="controlType"  style={{ width: "100%" }}>
            <Select
             style={{ width: "100%" }}
              labelInValue
              onChange={(value) => {
                form.setFieldsValue({ controlType: value });
              }}
              onDropdownVisibleChange={fetchSelectDataControlType}
              options={selectOptionsControlType}
              allowClear
              disabled={edit}
            />
          </Form.Item>
          <Space>
            <Form.Item label={intl("paragraph-no")} name="paragraphNo">
              <Input />
            </Form.Item>
            <Form.Item label={intl("appendix-no")} name="appendixNo">
              <Input />
            </Form.Item>
          </Space>
          <Form.Item label={intl("control-notes")} name="controlNotes">
            <Input />
          </Form.Item>
        </Space>
        </Space>
      )}
    <Space className={styles["wrapperTypeControl2"]}>
      <span className={styles["titleForWrapper"]}>{intl("content-action-stage")}</span>
      <Form.Item name="contentActionStage">
        <TextArea rows={4} />
      </Form.Item>
      <Form.Item label={intl("notes")} name="notes">
        <Input />
      </Form.Item>
    </Space>
    </DrawerProvider>
    </>
  );
}

export function RelatedDocuments({ pathname }: { pathname: string }) {
  const { intl } = useContext(TranslationContext);
  const { form } = useContext(FormContext);
  const { activeModal } = useContext(ModalContext);
  const { sessionData } = useContext(SessionContext);
  const { rowData } = useContext(TableContext);
  const edit = activeModal === "edit";
  const [typesOfCommunicationId, setTypesOfCommunicationId] = useState<number | undefined>(edit ? sessionData.eta_TypeDoc_relation_id : undefined);
  const [documentId, setDocumentId] = useState<number | undefined>(edit ? sessionData.bta_documents_id_parent : undefined);
  // const [selectData, setSelectData] = useState<MergedColumnType[]>([]);

  // const selectOptions = selectData.map((item) => ({
  //   value: item.id,
  //   label: item.name,
  // }));

  function setFormFields() {
    if (/* edit &&  */ rowData) {
      const fieldsValue: any = {};
      if (rowData["/directories/types-of-communication"]) {
        fieldsValue.typesOfCommunication =
          rowData["/directories/types-of-communication"].id;
          setTypesOfCommunicationId(rowData["/directories/types-of-communication"].id);
      }
      if (rowData["/documents/list-of-documents"]) {
        fieldsValue.document = rowData["/documents/list-of-documents"].id;
        setDocumentId(rowData["/documents/list-of-documents"].id);
      }
      form.setFieldsValue(fieldsValue);
    }
  }

  // const fetchSelectData = async () => {
  //   const content = (
  //     await request(`${pathname}/getdataselect`, {
  //       method: "get",
  //       cancelTokenKey: "getdataselect",
  //     })
  //   )?.content;
  //   setSelectData(content || []);
  // };

  return (
    <>
      <DrawerProvider>
      <Form.Item
        label={intl("types-of-communication")}
        name="typesOfCommunication"
        rules={[
          {
            required: true,
            // message: intl("last-name-required"),
          },
        ]}
      >
        <Drawer
          url="/directories/types-of-communication"
          name={edit ? sessionData.name_TypeDoc_relation : undefined}
          name2={rowData["/directories/types-of-communication"]?.data.Name}
          setFormFields={setFormFields}
          fieldName={"typesOfCommunication"}
        >
          <Directories url="/directories/types-of-communication" selectedRowId={typesOfCommunicationId}/>
        </Drawer>
      </Form.Item>
      {/* <Form.Item label={intl("document-type")} name="documentType">
        <Select
          labelInValue
          onChange={(value) => {
            form.setFieldsValue({ documentType: value });
          }}
          onDropdownVisibleChange={fetchSelectData}
          options={selectOptions}
          allowClear
          disabled={edit}
        />
      </Form.Item> */}
      <Form.Item
        label={intl("document")}
        name="document"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Drawer
          url="/documents/list-of-documents"
          name={
            edit
              ? `${sessionData.Name_TypeDoc ?? ""} ${
                  sessionData.num_doc ?? ""
                } ${
                  sessionData.date_doc
                    ? dayjs(sessionData.date_doc).format("DD.MM.YYYY")
                    : ""
                }`
              : undefined
          }
          name2={`${
            rowData["/documents/list-of-documents"]?.data.Name_TypeDoc ?? ""
          } ${
            rowData["/documents/list-of-documents"]?.data.num_doc ?? ""
          } ${intl("from")} ${dayjs(
            rowData["/documents/list-of-documents"]?.data.date_doc
          ).format("DD.MM.YYYY")}`}
          setFormFields={setFormFields}
          fieldName={"document"}
          disabled={edit}
        >
          <Documents url="/documents/list-of-documents" />
        </Drawer>
      </Form.Item>
      <Form.Item label={intl("notes")} name="notes">
        <Input />
      </Form.Item>
      </DrawerProvider>
      </>
  );
}

export function Discussion({ pathname }: { pathname: string }) {
  const { intl } = useContext(TranslationContext);

  return (
    <>
      <Form.Item label={intl("message")} name="message">
        <Input />
      </Form.Item>
    </>
  );
}
